import { format, getTime, formatDistanceToNow, differenceInDays } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function formatRelativeTime(date) {
  if (!date) return '';
  const d = new Date(date);
  const now = new Date();
  const daysDiff = differenceInDays(now, d);

  if (daysDiff < 7) {
    return formatDistanceToNow(d, { addSuffix: true });
  }
  if (d.getFullYear() === now.getFullYear()) {
    return format(d, 'MMM d');
  }
  return format(d, 'MMM d, yyyy');
}
